
var tagLess = {};
import genaration from '../../utils/classname';
export var tagClass = genaration(tagLess, 'tag');